import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './page-intro-article.component.scss';
var PageIntroArticle = /** @class */ (function (_super) {
    tslib_1.__extends(PageIntroArticle, _super);
    function PageIntroArticle(element) {
        return _super.call(this, element) || this;
    }
    PageIntroArticle.prototype.init = function () { };
    PageIntroArticle.prototype.bindEvents = function () { };
    return PageIntroArticle;
}(Base));
export { PageIntroArticle };



//////////////////
// WEBPACK FOOTER
// ./components/page-intro-article/page-intro-article.component.ts
// module id = 431
// module chunks = 0